import * as $ from 'jquery';
import LoadingAnimationHelper from './Helper/LoadingAnimationHelper';
import EqualHeightGridController from './EqualHeightGridController';

/**
 * AjaxController
 *
 * @author Felix König <f.koenig@andersundsehr.com>
 * @author Christian Benthake <c.benthake@andersundsehr.com>
 */
export default class AjaxController {
  private $ajaxContainer = $('.js-ajaxList');

  constructor() {
    if (this.$ajaxContainer.length) {
      this.showNews($('.js-ajaxItem'));
      this.removeItemsFromNews(this.getContainerItems());
      this.appendYearSeparator();
      $(document).on('click', '.f3-widget-paginator li.next a', (event) => {
        const link = $(event.target).attr('href');
        $(event.target).parent().parent().remove();
        this.getNextTestimonials(link);
        return false;
      });
    }
  }

  /**
   * Start ajax request
   * @param link
   */
  getNextTestimonials(link) {
    const loadingAnimationHelper = new LoadingAnimationHelper();
    loadingAnimationHelper.appendLoadingAnimation(this.$ajaxContainer.parent());

    const itemList = Array.prototype.slice.call($('.js-ajaxList')[0].childNodes).filter((x) => {
      if (!x || typeof x.classList === 'undefined') {
        return false;
      }
      return x.classList.contains('js-ajaxItem');
    });
    const url = this.getUrl(link, itemList);
    $.ajax({
      type: 'GET',
      url: url,
      success: (result) => {
        const $result = $(result);
        const $html = $result.find('.js-ajaxItem');
        this.$ajaxContainer.append($html);
        this.$ajaxContainer.append($result.find('.f3-widget-paginator'));
        this.showNews($html);
        if ($html.length === 15) {
          this.removeItemsFromNews(this.getContainerItems());
        }
        this.appendYearSeparator();
      },
      complete: () => {
        const loadingAnimationHelperInner = new LoadingAnimationHelper();
        loadingAnimationHelperInner.removeLoadingAnimation(this.$ajaxContainer.parent());
      },
    });
  }

  getUrl(link, itemList) {
    const linkParams = this.deParametrization(link);
    linkParams['tx_auspage_onelevelnavigationnoncached[filter][offset]'] = itemList.length + 1;
    // fallback: delete cHash
    const cHash = 'cHash';
    delete linkParams[cHash];
    return link.split('?')[0] + '?' + jQuery.param(linkParams);
  }

  /**
   * getContainerItems
   * list of nodes either after year separator or of all items within the container
   * @returns object jQuery-Object-Array
   */
  getContainerItems() {
    const year = this.getYears().sort((a, b) => {
      return parseInt(a, 10) - parseInt(b, 10);
    });
    if (!year[0]) {
      return '';
    }
    const ajaxContainerChildren = this.$ajaxContainer.find('[data-year=' + year[0] + ']');
    const newsItems: Array<any> = [];
    for (let i = 0; i < ajaxContainerChildren.length; i++) {
      if ($(ajaxContainerChildren[i]).hasClass('js-ajaxItem')) {
        newsItems.push(ajaxContainerChildren[i]);
      }
    }
    return jQuery(newsItems);
  }

  /**
   * reduces the items in grid to an equal amount per row
   * @param $news
   */
  removeItemsFromNews($news) {
    if (!$news) {
      return;
    }
    // e.g. if the row has 4 items and there are 14 items in total, then 2 items are removed
    const width = $news.first()[0].clientWidth;
    const widthParent = $news.first()[0].parentNode.clientWidth;
    const itemCount = parseInt(widthParent / width + '', 10);
    const modulo = $news.length % itemCount;
    if ($news.length > itemCount && modulo !== 0) {
      const parent = $news.first()[0].parentNode;
      for (let $i = 1; $i <= modulo; $i++) {
        parent.removeChild($news[$news.length - $i]);
      }
    }
  }

  getYears() {
    return this.$ajaxContainer.find('[data-year]').map((index, elem) => {
      return $(elem).attr('data-year');
    }).toArray().reduce(
      (current: Array<any>, next) => {
        if (next !== current[0]) {
          current.unshift(next);
        }
        return current;
      },
      [],
    );
  }

  /**
   * adds for every new year a separator
   */
  appendYearSeparator() {
    // unique array of years
    const highlightYear = $('.js-highlightDate').attr('data-year');
    const allYears = this.getYears();
    // adds the separator for each year once
    for (let $i = 1; $i < allYears.length; $i++) {
      const element = this.$ajaxContainer.find('[data-year=' + allYears[$i] + ']').last();
      if (this.$ajaxContainer.find(element).next().hasClass('js-ajaxItem')) {
        const thisSeparator = $('<div class="news__yearSeparator clr"></div>').append('<p>' + this.$ajaxContainer.find(element).next().attr('data-year') + '</p>').prop('outerHTML');
        element.after(thisSeparator);
      }
    }

    if (allYears.indexOf(highlightYear) === -1) {
      const firstElement = this.$ajaxContainer.children().first();
      if (this.$ajaxContainer.find(firstElement).hasClass('js-ajaxItem')) {
        firstElement.before(
          $('<div class="news__yearSeparator clr"></div>').append(
            '<p>' + this.$ajaxContainer.find(firstElement).attr('data-year') + '</p>',
          ).prop('outerHTML'),
        );
      }
    }
  }

  showNews($news) {
    $news.each((index, elem) => {
      const $this = $(elem);
      // for the future reader: this is a workaround - dont question it
      const $link = $this.find('.button');
      $link.attr('href', $link.data('link'));
      if ($this.hasClass('js-hide')) {
        $this.show(() => {
          const equalHeightGridController = new EqualHeightGridController();
          equalHeightGridController.update();
        });
        $this.removeClass('js-hide');
      }
    });
  }

  /**
   * transforms the search query of an URL into an object
   */
  deParametrization(queryString) {
    const params = {};
    const result = queryString.substring(queryString.indexOf('?') + 1).replace(/\+/g, ' ').split('&');
    for (let i = result.length; i > 0;) {
      const pair = result[--i].split('=');
      params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return params;
  }
}
